import React, { useCallback } from 'react';
import deepEqual from 'fast-deep-equal/es6/react';
import { IconCheck } from '@rossum/ui/icons/tabler';
import { Button, ButtonProps, SvgIcon } from '@rossum/ui/material';
import { SidebarButtonFieldModel } from '../useSidebarData';
import { MagicContainer } from './shared/MagicContainer';

export type ButtonItemProps = Omit<ButtonProps, 'onClick'> & {
  item: SidebarButtonFieldModel;
  ghost?: boolean;
  onClick: (
    id: number,
    popupUrl?: string | null,
    canObtainToken?: boolean
  ) => void;
};

const ButtonItem = React.memo(
  ({ item, onClick, ghost, ...buttonProps }: ButtonItemProps) => {
    const handleClick = useCallback(() => {
      onClick(item.id, item.url, item.canObtainToken);
    }, [item.canObtainToken, item.id, item.url, onClick]);

    return (
      <MagicContainer
        sidebarScrollableRef={null}
        active={false}
        disabled={false}
        focusable={false}
        ghost={ghost}
        hasMagicLine={false}
      >
        <Button
          variant="outlined"
          color="secondary"
          {...buttonProps}
          onClick={handleClick}
          endIcon={
            item.isPendingValidation ? (
              <SvgIcon fontSize="small">
                <IconCheck />
              </SvgIcon>
            ) : null
          }
        >
          {item.label}
        </Button>
      </MagicContainer>
    );
  },
  (prev, next) => {
    return deepEqual(prev, next);
  }
);

ButtonItem.displayName = 'ButtonItem';

export { ButtonItem };
